import classNames from 'classnames'
import useIsMobile from '../../../modules/hooks/common/useIsMobile'

const ProgressBar = ({ target, current }) => {
  const isMobile = useIsMobile()

  const calculatePercentage = () => {
    return (current / target) * 100
  }
  const percentage = calculatePercentage()

  return (
    <div className="flex w-full flex-row items-center gap-8">
      <div className="mt-100 relative h-20 w-full rounded-[50px] bg-gray-100">
        <div
          className={classNames(
            'absolute h-20 bg-purple-400',
            percentage === 100 ? 'rounded-[50px]' : 'rounded-l-[50px]'
          )}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <div
        className={classNames('text-gray-700', isMobile ? 'Body2-14Md' : 'Body1-16Md')}
      >{`${current}/${target}`}</div>
    </div>
  )
}

export default ProgressBar
